module.exports = __webpack_public_path__ + "static/media/loyalty-icon@3x.50bc8474.png";